export const HEADER = {
  title: "TROVA UNA SCUOLA PER IMPARARE\nL'ITALIANO A MILANO",
  description:
    "Imparare la lingua italiana è importante se desideri sentirti bene e integrarti. A Milano ci sono tante scuole che da anni si impegnano a insegnare l'italiano a chi, per diversi motivi, si trova a vivere nella nostra città. Qui puoi trovare il corso più adatto alle tue esigenze.",
};

export const CategoryChoice = {
  Tutti: '0',
};
